import {
  OPEN_MODAL,
  CLEAR_INVITATION,
  LOGOUT,
  UPDATE_ACCOUNT,
  CHECK_ACCOUNT,
  UPDATE_INACTIVE_EVENTS,
  UPDATE_RECEIVE_NEWSLETTER,
  RESET_PASSWORD_TOKEN,
  DELETE_RESET_PASSWORD_TOKEN
} from '../actions/auth.js'

import { CLOSE_LOGIN_MODAL, SWITCH_TO_FORGOT_PASSWORD_CONFIRMATION } from '../actions/login'

const authReducer = (state = {}, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      let modalToOpen = action.modalToOpen
      let invitation = action.invitation
      if (modalToOpen) {
        return {
          ...state,
          modalToOpen: modalToOpen,
          invitation: invitation
        }
      }

    case CLEAR_INVITATION:
      return {
        ...state,
        modalToOpen: undefined,
        invitation: undefined
      }

    case UPDATE_ACCOUNT:
      let account = action.account
      if (account && account.token) {
        localStorage.setItem('token', account.token)
      }

      if (account && account.providedRequestedInfo) {
        localStorage.setItem('didDisplayManualApprovalScreen', true)
      }

      if (account && (account.email || account.invitation)) {
        return {
          ...state,
          account: account
        }
      } else if (account && account.error) {
        return {
          ...state,
          account: undefined,
          error: account.error
        }
      } else {
        return {
          ...state,
          account: undefined,
          error: undefined
        }
      }

    case CHECK_ACCOUNT:
      if (!state.account) {
        return state
      }

      if (action.account && action.account.token) {
        localStorage.setItem('token', account.token)
      }

      return {
        ...state,
        account: action.account,
        modalToOpen: undefined
      }

    case LOGOUT:
      console.log('LOG OUT')

      // logout from FB
      if (window.FB) {
        window.FB.logout()
      }

      // remove token
      localStorage.removeItem('token')
      localStorage.removeItem('didDisplayApprovalScreen')
      localStorage.removeItem('didDisplayManualApprovalScreen')

      return {
        ...state,
        account: undefined
      }

    case UPDATE_INACTIVE_EVENTS:
      return {
        ...state,
        account: { ...state.account, showUnapprovedEvents: action.allowInactiveEvents }
      }

    case UPDATE_RECEIVE_NEWSLETTER:
      return {
        ...state,
        account: { ...state.account, receiveNewsletter: action.allowReceiveNewsletter }
      }

    case RESET_PASSWORD_TOKEN:
      return {
        ...state,
        resetPasswordIdentifier: action.resetPasswordIdentifier
      }

    case DELETE_RESET_PASSWORD_TOKEN:
      return {
        ...state,
        resetPasswordIdentifier: null
      }

    case CLOSE_LOGIN_MODAL:
      return {
        ...state,
        resetPasswordIdentifier: null
      }

    case SWITCH_TO_FORGOT_PASSWORD_CONFIRMATION:
      return {
        ...state,
        resetPasswordIdentifier: null
      }

    default:
      return state
  }
}

export default authReducer



// WEBPACK FOOTER //
// ./src/reducers/auth.js